import awsExports from '../../aws-exports';

export type AmplifyEnv = 'dev' | 'prod' | 'unknown';

export function detectEnv(): AmplifyEnv {
   const endpoint = awsExports['aws_cloud_logic_custom']?.[0]?.endpoint || '';
    if (endpoint.includes('/develop')) {
        return 'dev';
    }
    if (endpoint.includes('/production')) {
        return 'prod';
    }
    return 'unknown';
}